import React from 'react';
import PropTypes from 'prop-types';

import Box from 'components/atoms/Box/Box';
import Typography from 'components/atoms/Typography/Typography';
import Link from 'components/atoms/Link/Link';
import { useFooterCopyrightStyles } from './footerCopyrightStyles';
import { Trans } from 'react-i18next';

/**
 * Custom FooterCopyright component.
 * @param {*} props
 */
export default function FooterCopyright(props) {
  const { entries, version } = props;
  const classes = useFooterCopyrightStyles();

  return (
    <Box className={classes.box}>
      <Typography className={classes.text} textSize="14px">
        <Trans i18nKey="dna24.footer.copyright" />{' '}
        <Link href="https://www.lifenome.com/">
          <Trans i18nKey="dna24.footer.companyName" />
        </Link>{' '}
        <Trans i18nKey="dna24.footer.allRightsReserved" />{' '}
        {version && 'v' + version}
      </Typography>
      {entries &&
        entries.map((entry) => {
          return <Typography className={classes.text}>{entry}</Typography>;
        })}
    </Box>
  );
}

FooterCopyright.propTypes = {
  /**
   * Array of optional values in the footer (e.g. company address, contact).
   */
  entries: PropTypes.array,
  /**
   * Optional app version.
   */
  version: PropTypes.string,
};
